import { passwordResetHandle } from '@/js/api/auth.ts';
import { clearField, FIELD_SELECTOR, showFieldError } from '@/js/fields.ts';
import { ERROR_REQUEST_TEXT, showErrorNotify, showSuccessNotify } from '@/js/notification.ts';

const SUCCESS_REQUEST_TEXT = 'Новый пароль установлен!';
function clearFormFields(form: HTMLFormElement) {
  const fields = form.querySelectorAll<HTMLElement>(FIELD_SELECTOR);
  for (const field of fields) {
    clearField(field);
  }
}
export function initPasswordResetHandleForm() {
  const form = document.querySelector<HTMLFormElement>('.js-form-password-reset-handle');
  if (!form)
    return;

  form.addEventListener('submit', passwordResetHandleFormSubmit);

  function passwordResetHandleFormSubmit(event: Event): void {
    event.preventDefault();
    if (!form) {
      return;
    }
    clearFormFields(form);
    void passwordResetHandleFormAsync(form);
  }

  async function passwordResetHandleFormAsync(form: HTMLFormElement): Promise<void> {
    const formData = new FormData(form);

    const urlParams = new URLSearchParams(window.location.search).get('token') ?? '';
    formData.append('token', urlParams);

    const password = formData.get('password')?.toString() ?? '';
    const passwordConfirmation = formData.get('password_confirmation')?.toString() ?? '';

    if (password !== passwordConfirmation) {
      showFieldError(form.querySelector('[name="password"]'), 'Ошибка! Пароли не совпадают');
      return;
    }
    if (password.length < 8) {
      showFieldError(form.querySelector('[name="password"]'), 'Ошибка! Пароль меньше 8 символов');
      return;
    }

    try {
      const response = await passwordResetHandle(formData);
      if (response.data?.success && (response.data.redirect_url != null)) {
        showSuccessNotify({ text: SUCCESS_REQUEST_TEXT });
        window.location.href = response.data.redirect_url;
      }
      else {
        showErrorNotify({ text: ERROR_REQUEST_TEXT });
      }
    }
    catch (error) {
      showErrorNotify({ text: ERROR_REQUEST_TEXT });
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }
}
